export const MANUAL = 0

export const SNS = 1

export const MANUAL_CMS_ONLY = 2
